import { defineSong } from '../types';

export default defineSong({
  id: 'peri',
  title: 'Peri',
  level: 3,
  key: 'Am',
  bpm: 123,
  // The recording is in 4/4; two-beat bars keep both chords of its F | E Am bars.
  beats: 2,
  pattern: 'D-DU',
  style: 'Pop rock',
  desc: '{{pc:A}} minörde VI–V–i: majör V, yani {{c:E}}, kısa sürüp tonik minöre bir sekizlik erken çözülüyor. Köprüde bas ♭II ile V, yani {{pc:Bb}} ile {{pc:E}} arasında gidip geliyor, ilk kıtada ise i–iv–VII–III dönüyor.',
  sections: [
    { name: 'Nakarat', bars: ['F', 'F', 'E', 'Am', 'F', 'F', 'E', 'Am', 'F', 'F', 'E', 'Am', 'F', 'F', 'E', 'Am'] },
    { name: 'Kıta', bars: ['Am', 'Am', 'Dm', 'Dm', 'G', 'G', 'C', 'C', 'Am', 'Am', 'Dm', 'Dm', 'G', 'G', 'C', 'C'] },
    { name: 'Köprü', bars: ['Bb', 'Bb', 'E', 'E', 'Bb', 'Bb', 'E', 'E'] },
    { name: 'Nakarat', bars: ['F', 'F', 'E', 'Am', 'F', 'F', 'E', 'Am', 'F', 'F', 'E', 'Am', 'F', 'F', 'E', 'Am'] },
    { name: 'Ara', bars: ['F', 'F', 'E', 'Am', 'F', 'F', 'E', 'Am'] },
    { name: 'Kıta', bars: ['F', 'F', 'E', 'Am', 'F', 'F', 'E', 'Am', 'F', 'F', 'E', 'Am', 'F', 'F', 'E', 'Am'] },
    { name: 'Köprü', bars: ['Bb', 'Bb', 'E', 'E', 'Bb', 'Bb', 'E', 'E'] },
    { name: 'Nakarat', bars: ['F', 'F', 'E', 'Am', 'F', 'F', 'E', 'Am', 'F', 'F', 'E', 'Am', 'F', 'F', 'E', 'Am'] },
    { name: 'Nakarat', bars: ['F', 'F', 'E', 'Am', 'F', 'F', 'E', 'Am', 'F', 'F', 'E', 'Am', 'F', 'F', 'E', 'Am'] },
  ],
  cover: {
    artist: 'Nil Karaibrahimgil',
    references: [
      'https://akormatik.com/pages/song/nil-karaibrahimgil-peri',
      'https://orijinalton.com/Akorlar/AkorTab/1645/Nil-Karaibrahimgil/Peri',
      'https://www.songsterr.com/a/wsa/nil-karaibrahimgil-peri-ft-ayben-tab-s4866531',
    ],
    year: 2006,
    listen: 'https://www.youtube.com/watch?v=KIcLlieUpOk',
  },
});
